export default __webpack_public_path__ + "static/media/bot_kerjoo.cd608332.jpg";